import React from "react";
import useCustomerContext from "Contexts/customer-context";
import useUserContext from "Contexts/user-context";
import { CustomerContext, CustomerStatus } from "Shared/util/types";
import { differenceInDays } from "date-fns";
import DefaultView from "./views/default/default-view";
import DefaultEmptyStateView from "./views/empty-state/default/default-empty-state-view";
import OnboardingEmptyStateView from "./views/empty-state/onboarding/onboarding-empty-state-view";

const renderLandingView = (customer?: CustomerContext) => {
    const {
        activeErpIntegration,
        latestInvoiceDate,
        status: customerStatus,
    } = customer || {};

    const { status } = customerStatus || {};

    const isFirstTimeOnboardingCustomer =
        status === CustomerStatus.ONBOARDING_IN_PROGRESS;
    const isFirstTimeCustomer = !latestInvoiceDate;
    const isIdleCustomer =
        latestInvoiceDate &&
        differenceInDays(new Date(), new Date(latestInvoiceDate)) >= 60;

    if (isFirstTimeOnboardingCustomer) {
        return <OnboardingEmptyStateView />;
    } else if (activeErpIntegration) {
        return <DefaultView activeErpIntegration={activeErpIntegration} />;
    } else if (isFirstTimeCustomer) {
        return <DefaultEmptyStateView firstTimeUser />;
    } else if (isIdleCustomer) {
        return <DefaultEmptyStateView firstTimeUser={false} />;
    } else {
        return <DefaultView />;
    }
};

const LandingPage = () => {
    const { customerData, loadingCustomerData } = useCustomerContext();
    const { activeCompanyId } = useUserContext();

    const pageReady = !loadingCustomerData && activeCompanyId > 0;
    return pageReady ? renderLandingView(customerData) : null;
};

export default LandingPage;
